import { types } from 'mobx-state-tree';

import ApiActionFactory from '../../api/api-action-factory';
import StoreFactory from '../factories/store';

import ExternalInformationModel from './models/external-information-model';

import { isDev } from '@utils/build-utils';

import { RESOURCE_LIST_STATIC_ENDPOINT } from '@/api/endpoints';

const StaticVideoStore = StoreFactory({
    modelName: 'YoutubeStore',
    models: [
        ApiActionFactory({
            getVideos: {
                endpoint: RESOURCE_LIST_STATIC_ENDPOINT,
                target: 'staticVideos',
            },
        }),
    ],
    modelStructure: {
        isLoading: false,
        staticVideos: types.array(ExternalInformationModel),
    },
})
    .actions((self) => ({
        retrieveList() {
            self.getVideos();
        },
    }))
    .views((self) => ({
        getListById(listId: string) {
            //ToDo Use listId
            return self.staticVideos;
        },
    }));

const StaticVideoStoreInstance = StaticVideoStore.create();
declare const window: Window &
    typeof globalThis & {
        StaticVideoStore: typeof StaticVideoStoreInstance;
    };

if (window && isDev()) {
    window.StaticVideoStore = StaticVideoStoreInstance;
}

export default StaticVideoStore;
